import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function CorrelationDialog({ corrPopupData, setCorrPopupData, setVizConfig }) {
  return (
    <Dialog open={!!corrPopupData} onOpenChange={v => { if (!v) setCorrPopupData(null); }}>
      <DialogContent className="glass-card border-border/50 rounded-2xl sm:max-w-lg max-h-[80vh] overflow-auto" data-testid="pinned-correlation-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-emerald-400"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg> What Drives This Metric?</DialogTitle><DialogDescription className="text-xs text-muted-foreground">AI-powered correlation analysis of your data.</DialogDescription></DialogHeader>
        {corrPopupData?.data && (
          <div className="space-y-3 mt-2">
            <div className="p-3 rounded-xl bg-emerald-500/10 border border-emerald-500/20">
              <p className="text-xs text-foreground/80">{corrPopupData.data.summary}</p>
            </div>
            {(corrPopupData.data.drivers || []).map((d, i) => (
              <div key={i} className="p-2.5 rounded-lg border border-border/30 text-[10px]">
                <div className="flex items-center justify-between mb-1">
                  <span className="font-semibold text-foreground">{d.field?.replace(/_/g, ' ')}</span>
                  <span className={`text-[8px] font-bold ${d.correlation?.includes('positive') ? 'text-sky-400' : 'text-rose-400'}`}>{d.correlation}</span>
                </div>
                <p className="text-foreground/70">{d.insight}</p>
              </div>
            ))}
            {corrPopupData.data.recommendation && (
              <div className="p-2.5 rounded-lg bg-primary/5 border border-primary/20 text-[10px]">
                <span className="text-primary font-semibold">Recommendation:</span>
                <span className="text-foreground/80 ml-1">{corrPopupData.data.recommendation}</span>
              </div>
            )}
            <Button variant="outline" size="sm" className="w-full rounded-lg text-xs text-destructive hover:bg-destructive/10" onClick={() => { if (corrPopupData?.vizId) setVizConfig(corrPopupData.vizId, { pinnedCorrelation: null }); setCorrPopupData(null); }} data-testid="unpin-correlation-btn">Remove from Report</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
